import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PartnerAccessFrequencyGauge from './PartnerAccessFrequencyGauge';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';
import { PartnerAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';

class PartnerAccessFrequencyCompanyGaugeContainer extends React.Component {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    PartnerAccessFrequencyListService.load();
  }

  render() {
    const data = toJS(PartnerAccessFrequencyListService.getByCompanyId(this.props.companyId));
    return (
      <PartnerAccessFrequencyGauge
        loading={
          PartnerAccessFrequencyListService.fetchCurrent.fetching ||
          PartnerAccessFrequencyListService.fetchPrevious.fetching
        }
        currentValue={data.current}
        previousValue={data.previous}
        onClickHistory={() =>
          CustomerSuccessHistoryService.openDialog('PARTNER_ACCESS_FREQUENCY', this.props.companyId)
        }
        usersLink={`/company-users?company=${this.props.companyId}`}
        formatter={PartnerAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerAccessFrequencyCompanyGaugeContainer);
